import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseController } from '~client/controller/base-controller';
import { ClientProfileResponse } from '~client/model/client-profile-response';
import { ClientUserCreateRequest } from '~client/model/client-user-create-request';
import { ClientUserLoginRequest } from '~client/model/client-user-login-request';
import { ClientUserLoginResponse } from '~client/model/client-user-login-response';
import { ClientUserProfileResponse } from '~client/model/client-user-profile-response';
import { InitiateResetPasswordClientUserRequest } from '~client/model/initiate-reset-password-client-user-request';
import { ResponseEntity } from '~client/model/response-entity';
import { ChangePasswordRequest } from '~client/model/change-password-request';
import { AuthEmailVerificationResponse } from '~client/model/auth-email-verification-response';

/* Functions for maintaining Client User Logins */
export class ClientUserController extends BaseController {
  /* Allows a Client User to login */
  public login$(request: ClientUserLoginRequest): Observable<ClientUserLoginResponse> {
    return this.post$<ClientUserLoginResponse>('/auth/client/login', request).pipe(
      tap((response) => this.setAuthorization(response.authToken)),
    );
  }

  public logout$(): Observable<ResponseEntity> {
    return this.put$<ResponseEntity>('/auth/client/logout').pipe(
      tap(() => this.removeAuthorization()),
    );
  }

  /* Retrieves the personal profile of a Client Company */
  public getProfile$(): Observable<ClientProfileResponse> {
    return this.get$('/auth/client/profile');
  }

  /* Allows the client user to change their password after they have entered the verification code */
  public changePassword$(request: ChangePasswordRequest): Observable<ClientUserLoginResponse> {
    return this.put$<ClientUserLoginResponse>('/auth/client/public/changePassword', request).pipe(
      tap((response) => this.setAuthorization(response.authToken)),
    );
  }

  /* Verifies the users code for resetting their password */
  public verifyResetPasswordEmail$(token: string): Observable<AuthEmailVerificationResponse> {
    return this.get$('/auth/client/public/verifyResetPasswordEmail', { token });
  }

  /* Retrieves the personal profile of a Client User */
  public getUserProfile$(): Observable<ClientUserProfileResponse> {
    return this.get$('/auth/client/user/profile');
  }

  /* Creates a new Client User */
  public createUser$(request: ClientUserCreateRequest): Observable<ResponseEntity> {
    return this.post$('/auth/client/user/createAccount', request);
  }

  /* Allows the user to begin the reset password flow */
  public resetPassword$(request: InitiateResetPasswordClientUserRequest): Observable<any> {
    return this.put$('/auth/client/public/initiateResetPassword', request);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/client-user-controller.ts